<template>
  <div v-if="!this.$authentication.loading">
    <div v-if="this.getProfile">
      <h3 class="font-weight-500">Tu confirmación de compra será enviado a:</h3>
      <h3 class="font-weight-500" style="color: #000">
        {{ this.getProfile ? this.getProfile.email : '' }}
      </h3>
    </div>
    <div v-else>
      <div v-if="!this.otpCode">
        <div v-if="createAccount">
          <h3 class="font-weight-500">
            Solo necesita crear una cuenta para que puedas comprar nuestros cursos
            y empezar tu aprendizaje.
          </h3>
          <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
            <form
              class="form-checkout"
              role="form"
              @submit.prevent="handleSubmit(onSubmit)"
            >
              <md-field class="mb-0 mt-0">
                <label class="auth-container__label"
                >Correo electrónico</label
                >
                <md-input
                  v-model="userData.email"
                  :rules="emailRules"
                  alternative
                  name="Email"
                  @blur="validateEmail"
                ></md-input>
              </md-field>
              <!--                      <div-->
              <!--                        v-if="errorEmailExist"-->
              <!--                        class="error-message-register"-->
              <!--                      >-->
              <!--                        <span>-->
              <!--                          {{ errorEmailExist }}-->
              <!--                        </span>-->
              <!--                      </div>-->

              <div v-if="errors.email" class="error-message-register">
                        <span>
                          {{ errors.email }}
                        </span>
              </div>

              <div class="text-center">
                <base-button
                  :disabled="validateFields"

                  :loading="isLoading"
                  block
                  class="my-3"
                  native-type="submit"
                  type="dark"
                >Continuar
                </base-button>
              </div>
            </form>
          </validation-observer>

          <p class="text-center">
            ¿Ya tienes una cuenta?
            <span class="register-user-checkout" @click="registerUser">
            Inicia sesión
          </span>
          </p>
        </div>
        <div v-else>
          <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
            <form
              class="login-form-checkout"
              role="form"
              @submit.prevent="handleSubmit(onSubmit)"
            >
              <md-field class="mb-0 mt-0">
                <label class="auth-container__label"
                >Correo electrónico</label>
                <md-input
                  v-model="userData.email"
                  :rules="emailRules"
                  alternative
                  name="Email"
                  @blur="validateEmail"
                ></md-input>
              </md-field>
              <div v-if="errors.email" class="error-message-register">
                        <span>
                          {{ errors.email }}
                        </span>
              </div>

              <div class="text-center">
                <base-button
                  :loading="isLoading"
                  block
                  class="mt-4"
                  native-type="submit"
                  type="dark"
                  :disabled="validateFields"
                >Continuar
                </base-button>
              </div>
            </form>
          </validation-observer>
          <div class="d-flex my-3 justify-content-center">
            <p class="mr-1 mb-0">
              ¿No tienes una cuenta?
              <span
                class="mr-1 mb-0 create-account-pointer"
                @click="registerUser"
              >Crea tu cuenta
            </span>
            </p>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="card-body py-0">
          <div class="text-center text-muted mb-0">
            <div class="auth-container__form__title text-default">
              <h2 class="text-default">REVISA TU BANDEJA DE ENTRADA</h2>
            </div>
            <div class="auth-container__form__description text-default">
              <h3 class="text-default">
                Para continuar, ingresa el código que acabamos de enviarte a {{ this.email }}
              </h3>
            </div>
          </div>
          <validation-observer
            ref="formValidator"
            v-slot="{ handleSubmit }"
          >
            <form role="form" @submit.prevent="handleSubmit(onSubmitOtp)">
              <div style="display: flex; flex-direction: row;">
                <v-otp-input
                  ref="otpInput"
                  style="width:100%;justify-content: space-between;"
                  input-classes="otp-input"
                  separator=""
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-complete="handleOnComplete"
                />
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="text-center">
                    <base-button
                      block
                      :disabled="!data.otp"
                      :loading="buttonLoading"
                      class="mt-4"
                      native-type="submit"
                      type="dark"
                    >Continuar
                    </base-button>
                  </div>
                </div>
              </div>
            </form>
          </validation-observer>
        </div>

        <div>
          <div class="col-12 text-center text-white mt-3">
            <div class="auth-link" @click="resendCode" style="cursor: pointer;">
              <small class="text-default">¿No has recibido el código? Reenviar</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <loading-panel style="z-index: 6; height: 250px" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from '../../../../../components/BaseButton';
import LoadingPanel from '../../../../../components/LoadingPanel';
import { AUTH_CHECK_CODE, AUTH_MAGIC_LINK } from '@/store/actions/login';
import {
  USER_EMAIL_VERIFICATION,
} from '@/store/actions/register';
import { CHECKOUT_CHANGE_STEP } from '@/store/actions/checkout';
import { CHECKOUT_SECOND_STEP } from '@/util/constants';
import validator from 'validator';
import OtpInput from '@bachdgvn/vue-otp-input';

export default {
  name: 'CheckoutUserCart',
  components: {
    VOtpInput: OtpInput,

    BaseButton,
    LoadingPanel,

  },
  data () {
    return {
      vm: this,
      createAccount: false,
      isLoading: false,
      rules: [
        { message: 'Se requiere una letra minúscula.', regex: /[a-z]+/ },
        { message: 'Se requiere una letra mayúscula.', regex: /[A-Z]+/ },
        { message: 'Se requiere un número.', regex: /[0-9]+/ },
        { message: '8 caracteres como mínimo.', regex: /.{8,}/ },
      ],
      validPassword: {
        strong: 0,
        message: '',
        alert: '',
      },
      errorMessage: null,
      userData: {
        email: '',
      },
      data: {
        otp: '',
      },
      emailRules: {
        email: true,
      },
      buttonLoading: false,

      EmailVerification: '',
      errorEmailExist: '',
      inputOptions: {
        placeholder: 'Teléfono (Opcional)',
      },
      errors: {},
      otpCode: '',
      email: '',
      originalName: '',
    };
  },
  computed: {
    ...mapGetters(['getProfile', 'getAllCountries', 'getUserRequestError']),
    validateFields: function() {
      const email = this.userData.email;
      console.log({ email, error: this.errorEmailExist });
      return !(email.length && validator.default.isEmail(email));
    },
  },
  watch: {
    getProfile: function(newValue) {
      if (newValue.email) {
        this.$store.dispatch(CHECKOUT_CHANGE_STEP, CHECKOUT_SECOND_STEP);
      }
    },
  },
  mounted () {
    this.checkIfExistsProfile();
  },
  methods: {
    checkIfExistsProfile () {
      if (this.getProfile) {
        this.$store.dispatch(CHECKOUT_CHANGE_STEP, CHECKOUT_SECOND_STEP);
      }
    },
    registerUser () {
      this.createAccount = !this.createAccount;
      this.errors.email = '';
    },
    handleOnComplete (value) {
      this.data.otp = value;
    },
    onSubmitOtp () {
      const otp = this.data.otp;
      if (otp.length !== 6) {
        return this.notify(
          'danger',
          'El código es incorrecto',

        );
      }

      this.buttonLoading = true;
      console.log(otp);
      this.$store
        .dispatch(AUTH_CHECK_CODE, { otp })
        .then((data) => {

          if (!data.success) {
            return this.notify(
              'danger',
              'El código es incorrecto o ha expirado',

            );
          }

          window.location.reload();
        })
        .finally(() => (this.buttonLoading = false));

    },
    onSubmit () {
      this.isLoading = true;

      let data = {
        email: this.userData.email,
      };
      this.$store
        .dispatch(AUTH_MAGIC_LINK, data)
        .then((data) => {
          this.otpCode = data.code;

          const [alias, domain] = data.email.replaceAll(/(?<=.).(?=.*@)/g, '*').split('@');
          const [prefix, abv] = domain.split('.');
          const maskedPrefix = prefix.replaceAll(/(?<=.)./g, '*');
          this.email = `${alias}@${maskedPrefix}.${abv}`;
          this.originalEmail = data.email;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => (this.isLoading = false));
    },
    resendCode () {
      let data = {
        email: this.originalEmail,
      };
      this.$store
        .dispatch(AUTH_MAGIC_LINK, data)
        .then((data) => {

          if (data.code) {
            this.notify(
              'success',
              'El código se ha enviado a correo electrónico ',

            );

            window.location.href = `/verify-user/${data.code}`;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
    notify (type, message) {
      this.$notify({
        type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message,
      });
    },
    validateEmail () {
      let email = this.userData.email;
      this.$store
        .dispatch(USER_EMAIL_VERIFICATION, email)
        .then((resp) => {
          this.EmailVerification = resp.data;
          if (this.EmailVerification) {
            this.errorEmailExist =
              '¡Ya existe una cuenta con ese correo electrónico!';
          } else {
            this.errorEmailExist = null;
          }
        })
        .catch(() => {});

      if (email && !validator.default.isEmail(email)) {
        console.log('error email');
        this.errors.email = 'El formato del correo es incorrecto';
      } else {
        delete this.errors.email;
      }
    },

  },
};
</script>

<style>
.create-account-pointer {
  color: #b7227e !important;
}

.multiselect-checkout-user-cart-countries .multiselect input {
  border: 0px;
}

::placeholder,
.multiselect__placeholder {
  color: #0000008a !important;
}

.register-user-checkout {
  background-color: #fff;
  color: #b7227e;
  cursor: pointer;
  padding: 0;
  outline: none;
  border: none;
  align-self: center;
}

.register-user-checkout:hover,
.register-user-checkout:focus,
.register-user-checkout:active {
  background-color: white !important;
  color: #b7227e !important;
  box-shadow: none !important;
}


.register-user-checkout-login {
  color: #b7227e;
  cursor: pointer;
  padding: 0;
}

.multiselect__input,
.multiselect__single {
  padding-left: 10px;
}

.multiselect__single {
  padding: 0px !important;
  margin-top: 13px !important;
  margin-bottom: 13px !important;
  border: none;
}

.multiselect__placeholder {
  padding-top: 0px !important;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 30px;
  font-size: 16px;
  letter-spacing: 0.01em;
}

.multiselect__select::before {
  top: 35%;
}

.multiselect__tags {
  padding: 0px 40px 0px 16px !important;
}

.multiselect__input {
  padding: 0px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-size: 16px;
  letter-spacing: 0.01em;
  line-height: 30px;
}

.form-checkout .md-field.md-theme-default label {
  color: rgba(0, 0, 0, 0.54);
}

.create-account-pointer {
  color: #000;
  cursor: pointer;
}

.border-none input {
  border: none !important;
}

.error-message-register,
.error-message-register span {
  background-color: rgb(226, 4, 4);
  color: white;
  width: 100%;
  text-align: center;
  padding: 5px;
  border-radius: 5px;
  margin-top: 14px !important;
  font-size: 14px !important;
}

.vue-tel-input.tel-register-input {
  width: 100%;
  height: 56px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.vue-tel-input.tel-register-input input::placeholder {
  color: #0000008a !important;
}


.tel-register-input .vti__dropdown-item strong {
  font-weight: 400;
}

.vti__input input {
  margin-bottom: 0px !important;
}

.login-form-checkout .md-field input {
  border: 1px solid #ddd;
}

.multiselect__content-wrapper {
  top: auto !important;
  bottom: 100% !important;
}
</style>
